import { render, staticRenderFns } from "./ServiciosView.vue?vue&type=template&id=5beb2d56&scoped=true"
import script from "./ServiciosView.vue?vue&type=script&lang=js"
export * from "./ServiciosView.vue?vue&type=script&lang=js"
import style0 from "./ServiciosView.vue?vue&type=style&index=0&id=5beb2d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb2d56",
  null
  
)

export default component.exports